import { render, staticRenderFns } from "./AppRegions.vue?vue&type=template&id=7d32524e&scoped=true&"
import script from "./AppRegions.vue?vue&type=script&lang=js&"
export * from "./AppRegions.vue?vue&type=script&lang=js&"
import style0 from "./AppRegions.vue?vue&type=style&index=0&id=7d32524e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d32524e",
  null
  
)

export default component.exports